export default __webpack_public_path__ + "static/media/slider4.8fc98d0b.jpg";